import checkout from "./form";
import * as Yup from "yup";

const {
  formField: { profesor, asignatura },
} = checkout;

const validation = [
  Yup.object({
    [profesor.name]: Yup.string()
      .nullable()
      .test(
        "conditional-required",
        "El Profesor es obligatorio cuando se selecciona una asignatura",
        function (value) {
          const { asignatura } = this.parent;
          // Si asignatura tiene valor, profesor es obligatorio
          if (asignatura && asignatura.length > 0) {
            return value && value.length > 0;
          }
          // Si no hay asignatura, profesor puede estar vacío
          return true;
        }
      ),
    [asignatura.name]: Yup.string()
      .nullable()
      .test(
        "conditional-required",
        "La Asignatura es obligatoria cuando se selecciona un profesor",
        function (value) {
          const { profesor } = this.parent;
          // Si profesor tiene valor, asignatura es obligatorio
          if (profesor && profesor.length > 0) {
            return value && value.length > 0;
          }
          // Si no hay profesor, asignatura puede estar vacío
          return true;
        }
      ),
  }),
];

export default validation;
